// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

// Shared utils for Display Items.
import * as utils from '../utils.jsx';

// Model objects.
import DisplayItem from '../../../model/entity/DisplayItem/DisplayItem.js';

import * as ItemUtils from '../utils';

import { ItemProfile, ItemNetworkIcon, ItemContent, ItemDate } from './item-components';

const DEFAULT_HEIGHT = 400; // pixels
const MOBILE_WIDTH = 520;

class PostCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.state = {};
  }
  isMobile() {
    return this.state.windowWidth <= MOBILE_WIDTH;
  }

  componentDidMount() {
    this.setState({ windowWidth: window.innerWidth });
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  handleRef(name) {
    this[`set${name}`] = domEle => (this[name] = domEle);
    return this[`set${name}`];
  }

  render() {
    const profile = _.get(this.props.item, 'profile');
    const { username, handle, avatar } = profile;
    const network = _.get(this.props.item, 'meta.network');
    const tags = _.get(this.props.item, 'meta.tags');
    const timestamp = _.get(this.props.item, 'meta.timestamp');
    const link = _.get(this.props.item, 'content.link');
    const originalContentAsset = ItemUtils.getItemAsset({
      item:        this.props.item.originalContent,
      assetUrl:    this.props.assetUrl,
      assetUgcUrl: this.props.assetUgcUrl,
      moduleOpts:  this.props.moduleOpts,
      itemOpts:    this.props.itemOpts,
    });

    const shouldAutoPlay = ItemUtils.shouldAutoPlay(
      _.get(this.props, ['moduleOpts', 'autoPlayConfig']),
      this.props.item
    );

    const wrapperClassName = utils.getClassNamesForItem({
      item:         this.props.item,
      templateOpts: this.props.templateOpts,
    });
    const height = Number(this.props.moduleOpts.height || DEFAULT_HEIGHT);
    const itemInnerStyle = !this.isMobile() ? { height: `${height}px` } : {};

    let mediaHeight, mediaWidth;
    if (this.card && shouldAutoPlay) {
      if (this.props.mediaWidth) {
        mediaWidth = this.props.mediaWidth(this.card.clientWidth);
      }
      if (this.props.mediaHeight) {
        mediaHeight = this.props.mediaHeight(this.card.clientHeight);
      }
    }
    let itemAsset;
    if (React.isValidElement(this.props.itemAsset)) {
      itemAsset = React.cloneElement(this.props.itemAsset, { styles: { width: mediaWidth, height: mediaHeight } });
    }

    // Pass a height and width calc function here
    return (
      <div
        className={wrapperClassName}
        data-ngx-tags={tags}
        data-ngx-id={this.props.item.id}
        onClick={() => this.props.onClick(this.props.item)}
        ref={this.handleRef('card')}
      >
        <div className="xItemInner" style={itemInnerStyle}>
          <If condition={!!itemAsset || !!originalContentAsset}>
            <div className="xItemLeft">{itemAsset || originalContentAsset}</div>
          </If>
          <div className="xItemRight">
            <div className="xItemRightTop">
              <div className="xItemRightContentWrapper">
                <If condition={!!username || !!handle || !!avatar}>
                  <ItemProfile
                    username={username}
                    handle={handle}
                    avatar={avatar}
                    network={network}
                    originalHandle={_.get(this.props.item, 'originalContent.profile.handle')}
                    onExternalLinkClick={this.props.onExternalLinkClick}
                  />
                </If>
                <ItemContent
                  type="main"
                  heading={this.props.item.content.heading}
                  byline={this.props.item.content.byline}
                  description={this.props.item.content.description}
                  content={this.props.item.content.content}
                  caption={this.props.item.content.caption}
                  network={network}
                  displayedUrls={this.props.item.content.displayedUrls}
                  onExternalLinkClick={this.props.onExternalLinkClick}
                  tags={tags}
                />
                <ItemContent type="secondary" caption={this.props.item.content.caption} />
              </div>
              <ItemDate link={link} date={new Date(timestamp)} onExternalLinkClick={this.props.onExternalLinkClick} />
              {this.props.platformActions}
            </div>
            <div className="xItemRightBottom">
              <div className={'xPostcardActions'}>
                <ItemNetworkIcon network={network} />
                {this.props.networkActions}
                {this.props.sharingActions}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PostCard.propTypes = {
  item:                PropTypes.instanceOf(DisplayItem),
  assetUrl:            PropTypes.string,
  assetUgcUrl:         PropTypes.string,
  moduleOpts:          PropTypes.object,
  itemOpts:            PropTypes.object,
  platformActions:     PropTypes.element,
  networkActions:      PropTypes.element,
  sharingActions:      PropTypes.element,
  onExternalLinkClick: PropTypes.func,
  mediaWidth:          PropTypes.func,
  mediaHeight:         PropTypes.func,
};

PostCard.defaultProps = {
  item:                {},
  assetUrl:            undefined,
  assetUgcUrl:         undefined,
  moduleOpts:          {},
  templateOpts:        {},
  itemOpts:            {},
  platformActions:     null,
  networkActions:      null,
  sharingActions:      null,
  onExternalLinkClick: _.noop,
  mediaWidth:          _.noop,
  mediaHeight:         _.noop,
};

export default PostCard;
